<template>
  <v-card outlined class="mb-6" raised>
    <v-container fluid>
      <v-row dense>
        <v-col cols="12" sm="4" md="3"><v-text-field label="Template name" outlined dense v-model="recurringTransaction.name" :rules="[fieldRules.required,fieldRules.maxLength(50)]"/></v-col>
        <v-col cols="7" sm="3" md="2">
          <v-select label="Type" :items="['Scheduled','Reminder','Unscheduled']" outlined dense v-model="recurringTransaction.scheduleType"/>
        </v-col>
        <v-col cols="5" sm="3" md="2" v-show="recurringTransaction.scheduleType!=='Unscheduled'">
          <decimal-number-input label="Create in advance" prefix="" suffix="day(s)" :precision="0" v-model="recurringTransaction.advanceDays"/>
        </v-col>
        <v-col cols="6" sm="3" md="2" v-show="recurringTransaction.scheduleType!=='Unscheduled'">
          <date-picker date-only label="Starting" v-model="recurringTransaction.startDate"/>
        </v-col>
      </v-row>

      <v-row v-show="recurringTransaction.scheduleType!=='Unscheduled'" dense>
        <v-col cols="6" sm="3" md="2">
          <v-select label="Interval" :items="['Daily','Weekly','Monthly','Yearly']" outlined dense v-model="recurringTransaction.scheduleInterval"/>
        </v-col>

        <template v-if="recurringTransaction.scheduleInterval==='Daily'">
          <v-col cols="6" sm="3" md="2">
            <decimal-number-input label="Every" prefix="" suffix="day(s)" :precision="0" :min="1" v-model="recurringTransaction.frequency"/>
          </v-col>
        </template>

        <template v-else-if="recurringTransaction.scheduleInterval==='Weekly'">
          <v-col cols="6" sm="3" md="2">
            <decimal-number-input label="Every" prefix="" suffix="week(s)" :precision="0" :min="1" v-model="recurringTransaction.frequency"/>
          </v-col>
          <v-col cols="6" sm="3" md="2">
            <v-select label="On" :items="weekdayList" outlined dense v-model="recurringTransaction.dayOfWeek"/>
          </v-col>
        </template>

        <template v-else-if="recurringTransaction.scheduleInterval==='Monthly'">
          <v-col cols="6" sm="3" md="2">
            <v-select label="On" :items="['day','first','second','third','fourth','last']" outlined dense v-model="recurringTransaction.ordinal"/>
          </v-col>
          <template v-if="recurringTransaction.ordinal === 'day'">
            <v-col cols="6" sm="3" md="2">
              <v-select label="On" :items="dayList" outlined dense v-model="recurringTransaction.day"/>
            </v-col>
          </template>
          <v-col cols="6" sm="3" md="2" v-else>
            <v-select label="On" :items="weekdayList" outlined dense v-model="recurringTransaction.dayOfWeek"/>
          </v-col>
          <v-col cols="6" sm="3" md="2">
            <decimal-number-input label="of every" prefix="" suffix="month(s)" :precision="0" :min="1" v-model="recurringTransaction.frequency"/>
          </v-col>
        </template>

        <template v-else-if="recurringTransaction.scheduleInterval==='Yearly'">
          <v-col cols="6" sm="3" md="2" v-show="recurringTransaction.scheduleInterval==='Yearly'">
            <v-select label="Every" :items="monthsList" outlined dense v-model="recurringTransaction.month"/>
          </v-col>
          <v-col cols="6" sm="3" md="2" v-show="recurringTransaction.scheduleInterval==='Yearly'">
            <v-select label="On the" :items="dayList" outlined dense v-model="recurringTransaction.day"/>
          </v-col>
        </template>

        <template v-if="recurringTransaction.scheduleType!=='Unscheduled'">
          <v-col cols="6" sm="3" md="2">
            <v-select label="End" :items="['None','By','After']" outlined dense v-model="recurringTransaction.end"/>
          </v-col>
          <v-col cols="6" sm="3" md="2" v-show="recurringTransaction.end==='By'">
            <date-picker date-only label="End date" v-model="recurringTransaction.endDate"/>
          </v-col>
          <v-col cols="6" sm="3" md="2" v-show="recurringTransaction.end==='After'">
            <decimal-number-input prefix="" suffix="occurences" :precision="0" :min="1" v-model="recurringTransaction.endOccurances"/>
          </v-col>
        </template>
      </v-row>

    </v-container>
  </v-card>
</template>

<script>
import {format} from 'date-fns'

export default {
  name: 'RecurringTransaction',

  props: {
    value: {type:Object, required:true}
  },

  data: () => {
    return {
      recurringTransaction: {name:'', scheduleType: 'Scheduled', advanceDays:0, startDate:format(new Date(), 'yyyy-MM-dd'),
                             scheduleInterval: 'Daily', frequency:1, dayOfWeek:'Monday', ordinal:'day', day:1, month:'January',
                             end:'None', endDate:'2030-12-12', endOccurances:1},
      weekdayList: ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
      dayList: [{text:'1st',value:1},{text:'2nd',value:2},{text:'3rd',value:3}],
      monthsList: ['January','February','March','April','May','June',
                   'July','August','September','October','November','December']
    }
  },

  created() {
    for (let i = 4; i <= 28; i++)
      this.dayList.push({text:`${i}th`,value:i});
    this.dayList.push({text:'Last day',value:0});
    Object.assign(this.recurringTransaction, this.value)
  },

  watch: {
    value() {
       Object.assign(this.recurringTransaction, this.value);
    },
    recurringTransaction: {
      handler() {this.$emit('input', this.recurringTransaction)},
      immediate: true,
      deep: true
    }
  },

  methods: {
  }
}
</script>